/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CarrierActivationStatus } from "./CarrierActivationStatus";
import {
  CarrierActivationStatusFromJSON,
  CarrierActivationStatusFromJSONTyped,
  CarrierActivationStatusToJSON,
  CarrierActivationStatusToJSONTyped,
} from "./CarrierActivationStatus";
import type { CarrierRepInformation } from "./CarrierRepInformation";
import {
  CarrierRepInformationFromJSON,
  CarrierRepInformationFromJSONTyped,
  CarrierRepInformationToJSON,
  CarrierRepInformationToJSONTyped,
} from "./CarrierRepInformation";
import type { CountryCode } from "./CountryCode";
import {
  CountryCodeFromJSON,
  CountryCodeFromJSONTyped,
  CountryCodeToJSON,
  CountryCodeToJSONTyped,
} from "./CountryCode";

/**
 *
 * @export
 * @interface CarrierBasicProperties
 */
export interface CarrierBasicProperties {
  /**
   *
   * @type {string}
   * @memberof CarrierBasicProperties
   */
  displayName: string;
  /**
   *
   * @type {boolean}
   * @memberof CarrierBasicProperties
   */
  isCarrierPickupNumberSameAsProNumber: boolean;
  /**
   *
   * @type {string}
   * @memberof CarrierBasicProperties
   */
  mainTrackingNumber: string;
  /**
   *
   * @type {number}
   * @memberof CarrierBasicProperties
   */
  priceAdjustment: number;
  /**
   *
   * @type {Array<string>}
   * @memberof CarrierBasicProperties
   */
  carrierEmailDomains: Array<string>;
  /**
   *
   * @type {string}
   * @memberof CarrierBasicProperties
   */
  linearUrl: string;
  /**
   *
   * @type {boolean}
   * @memberof CarrierBasicProperties
   */
  mainTrackingNumberIsQuoteNumber: boolean;
  /**
   *
   * @type {CarrierActivationStatus}
   * @memberof CarrierBasicProperties
   */
  activationStatus: CarrierActivationStatus;
  /**
   *
   * @type {number}
   * @memberof CarrierBasicProperties
   */
  maxBillOfLadingLineItems: number;
  /**
   *
   * @type {boolean}
   * @memberof CarrierBasicProperties
   */
  doNotSendAmyEmails: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CarrierBasicProperties
   */
  doNotSendMissedPickupEmails: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CarrierBasicProperties
   */
  doNotSendMissedDeliveryEmails: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CarrierBasicProperties
   */
  doNotSendExpectedDeliveryInPastEmails: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CarrierBasicProperties
   */
  doNotSendTrackingNotUpdatedEmails: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CarrierBasicProperties
   */
  doNotAlarmWhenCarrierPickupNumberIsMissing: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CarrierBasicProperties
   */
  includeQuoteAmountOnPickupEmail: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CarrierBasicProperties
   */
  attachQuoteExplanationPdfToPickupEmail: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CarrierBasicProperties
   */
  sendBillOfLadingPickupEmails: boolean;
  /**
   *
   * @type {CountryCode}
   * @memberof CarrierBasicProperties
   */
  basedIn: CountryCode;
  /**
   *
   * @type {CarrierRepInformation}
   * @memberof CarrierBasicProperties
   */
  carrierRepInformation: CarrierRepInformation;
  /**
   *
   * @type {Array<CarrierRepInformation>}
   * @memberof CarrierBasicProperties
   */
  additionalCarrierReps?: Array<CarrierRepInformation> | null;
  /**
   *
   * @type {boolean}
   * @memberof CarrierBasicProperties
   */
  supportsCustomerSpecificPricing: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CarrierBasicProperties
   */
  customerSpecificPricingQuotingImplemented: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CarrierBasicProperties
   */
  customerSpecificPricingRequiresLOA: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CarrierBasicProperties
   */
  customerSpecificPricingUsesRateSheet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CarrierBasicProperties
   */
  usesFCAFuelSurcharge: boolean;
  /**
   *
   * @type {number}
   * @memberof CarrierBasicProperties
   */
  documentFetchCutOffDays: number;
}

/**
 * Check if a given object implements the CarrierBasicProperties interface.
 */
export function instanceOfCarrierBasicProperties(
  value: object,
): value is CarrierBasicProperties {
  if (!("displayName" in value) || value["displayName"] === undefined)
    return false;
  if (
    !("isCarrierPickupNumberSameAsProNumber" in value) ||
    value["isCarrierPickupNumberSameAsProNumber"] === undefined
  )
    return false;
  if (
    !("mainTrackingNumber" in value) ||
    value["mainTrackingNumber"] === undefined
  )
    return false;
  if (!("priceAdjustment" in value) || value["priceAdjustment"] === undefined)
    return false;
  if (
    !("carrierEmailDomains" in value) ||
    value["carrierEmailDomains"] === undefined
  )
    return false;
  if (!("linearUrl" in value) || value["linearUrl"] === undefined) return false;
  if (
    !("mainTrackingNumberIsQuoteNumber" in value) ||
    value["mainTrackingNumberIsQuoteNumber"] === undefined
  )
    return false;
  if (!("activationStatus" in value) || value["activationStatus"] === undefined)
    return false;
  if (
    !("maxBillOfLadingLineItems" in value) ||
    value["maxBillOfLadingLineItems"] === undefined
  )
    return false;
  if (
    !("doNotSendAmyEmails" in value) ||
    value["doNotSendAmyEmails"] === undefined
  )
    return false;
  if (
    !("doNotSendMissedPickupEmails" in value) ||
    value["doNotSendMissedPickupEmails"] === undefined
  )
    return false;
  if (
    !("doNotSendMissedDeliveryEmails" in value) ||
    value["doNotSendMissedDeliveryEmails"] === undefined
  )
    return false;
  if (
    !("doNotSendExpectedDeliveryInPastEmails" in value) ||
    value["doNotSendExpectedDeliveryInPastEmails"] === undefined
  )
    return false;
  if (
    !("doNotSendTrackingNotUpdatedEmails" in value) ||
    value["doNotSendTrackingNotUpdatedEmails"] === undefined
  )
    return false;
  if (
    !("doNotAlarmWhenCarrierPickupNumberIsMissing" in value) ||
    value["doNotAlarmWhenCarrierPickupNumberIsMissing"] === undefined
  )
    return false;
  if (
    !("includeQuoteAmountOnPickupEmail" in value) ||
    value["includeQuoteAmountOnPickupEmail"] === undefined
  )
    return false;
  if (
    !("attachQuoteExplanationPdfToPickupEmail" in value) ||
    value["attachQuoteExplanationPdfToPickupEmail"] === undefined
  )
    return false;
  if (
    !("sendBillOfLadingPickupEmails" in value) ||
    value["sendBillOfLadingPickupEmails"] === undefined
  )
    return false;
  if (!("basedIn" in value) || value["basedIn"] === undefined) return false;
  if (
    !("carrierRepInformation" in value) ||
    value["carrierRepInformation"] === undefined
  )
    return false;
  if (
    !("supportsCustomerSpecificPricing" in value) ||
    value["supportsCustomerSpecificPricing"] === undefined
  )
    return false;
  if (
    !("customerSpecificPricingQuotingImplemented" in value) ||
    value["customerSpecificPricingQuotingImplemented"] === undefined
  )
    return false;
  if (
    !("customerSpecificPricingRequiresLOA" in value) ||
    value["customerSpecificPricingRequiresLOA"] === undefined
  )
    return false;
  if (
    !("customerSpecificPricingUsesRateSheet" in value) ||
    value["customerSpecificPricingUsesRateSheet"] === undefined
  )
    return false;
  if (
    !("usesFCAFuelSurcharge" in value) ||
    value["usesFCAFuelSurcharge"] === undefined
  )
    return false;
  if (
    !("documentFetchCutOffDays" in value) ||
    value["documentFetchCutOffDays"] === undefined
  )
    return false;
  return true;
}

export function CarrierBasicPropertiesFromJSON(
  json: any,
): CarrierBasicProperties {
  return CarrierBasicPropertiesFromJSONTyped(json, false);
}

export function CarrierBasicPropertiesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierBasicProperties {
  if (json == null) {
    return json;
  }
  return {
    displayName: json["displayName"],
    isCarrierPickupNumberSameAsProNumber:
      json["isCarrierPickupNumberSameAsProNumber"],
    mainTrackingNumber: json["mainTrackingNumber"],
    priceAdjustment: json["priceAdjustment"],
    carrierEmailDomains: json["carrierEmailDomains"],
    linearUrl: json["linearUrl"],
    mainTrackingNumberIsQuoteNumber: json["mainTrackingNumberIsQuoteNumber"],
    activationStatus: CarrierActivationStatusFromJSON(json["activationStatus"]),
    maxBillOfLadingLineItems: json["maxBillOfLadingLineItems"],
    doNotSendAmyEmails: json["doNotSendAmyEmails"],
    doNotSendMissedPickupEmails: json["doNotSendMissedPickupEmails"],
    doNotSendMissedDeliveryEmails: json["doNotSendMissedDeliveryEmails"],
    doNotSendExpectedDeliveryInPastEmails:
      json["doNotSendExpectedDeliveryInPastEmails"],
    doNotSendTrackingNotUpdatedEmails:
      json["doNotSendTrackingNotUpdatedEmails"],
    doNotAlarmWhenCarrierPickupNumberIsMissing:
      json["doNotAlarmWhenCarrierPickupNumberIsMissing"],
    includeQuoteAmountOnPickupEmail: json["includeQuoteAmountOnPickupEmail"],
    attachQuoteExplanationPdfToPickupEmail:
      json["attachQuoteExplanationPdfToPickupEmail"],
    sendBillOfLadingPickupEmails: json["sendBillOfLadingPickupEmails"],
    basedIn: CountryCodeFromJSON(json["basedIn"]),
    carrierRepInformation: CarrierRepInformationFromJSON(
      json["carrierRepInformation"],
    ),
    additionalCarrierReps:
      json["additionalCarrierReps"] == null
        ? undefined
        : (json["additionalCarrierReps"] as Array<any>).map(
            CarrierRepInformationFromJSON,
          ),
    supportsCustomerSpecificPricing: json["supportsCustomerSpecificPricing"],
    customerSpecificPricingQuotingImplemented:
      json["customerSpecificPricingQuotingImplemented"],
    customerSpecificPricingRequiresLOA:
      json["customerSpecificPricingRequiresLOA"],
    customerSpecificPricingUsesRateSheet:
      json["customerSpecificPricingUsesRateSheet"],
    usesFCAFuelSurcharge: json["usesFCAFuelSurcharge"],
    documentFetchCutOffDays: json["documentFetchCutOffDays"],
  };
}

export function CarrierBasicPropertiesToJSON(
  json: any,
): CarrierBasicProperties {
  return CarrierBasicPropertiesToJSONTyped(json, false);
}

export function CarrierBasicPropertiesToJSONTyped(
  value?: CarrierBasicProperties | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    displayName: value["displayName"],
    isCarrierPickupNumberSameAsProNumber:
      value["isCarrierPickupNumberSameAsProNumber"],
    mainTrackingNumber: value["mainTrackingNumber"],
    priceAdjustment: value["priceAdjustment"],
    carrierEmailDomains: value["carrierEmailDomains"],
    linearUrl: value["linearUrl"],
    mainTrackingNumberIsQuoteNumber: value["mainTrackingNumberIsQuoteNumber"],
    activationStatus: CarrierActivationStatusToJSON(value["activationStatus"]),
    maxBillOfLadingLineItems: value["maxBillOfLadingLineItems"],
    doNotSendAmyEmails: value["doNotSendAmyEmails"],
    doNotSendMissedPickupEmails: value["doNotSendMissedPickupEmails"],
    doNotSendMissedDeliveryEmails: value["doNotSendMissedDeliveryEmails"],
    doNotSendExpectedDeliveryInPastEmails:
      value["doNotSendExpectedDeliveryInPastEmails"],
    doNotSendTrackingNotUpdatedEmails:
      value["doNotSendTrackingNotUpdatedEmails"],
    doNotAlarmWhenCarrierPickupNumberIsMissing:
      value["doNotAlarmWhenCarrierPickupNumberIsMissing"],
    includeQuoteAmountOnPickupEmail: value["includeQuoteAmountOnPickupEmail"],
    attachQuoteExplanationPdfToPickupEmail:
      value["attachQuoteExplanationPdfToPickupEmail"],
    sendBillOfLadingPickupEmails: value["sendBillOfLadingPickupEmails"],
    basedIn: CountryCodeToJSON(value["basedIn"]),
    carrierRepInformation: CarrierRepInformationToJSON(
      value["carrierRepInformation"],
    ),
    additionalCarrierReps:
      value["additionalCarrierReps"] == null
        ? undefined
        : (value["additionalCarrierReps"] as Array<any>).map(
            CarrierRepInformationToJSON,
          ),
    supportsCustomerSpecificPricing: value["supportsCustomerSpecificPricing"],
    customerSpecificPricingQuotingImplemented:
      value["customerSpecificPricingQuotingImplemented"],
    customerSpecificPricingRequiresLOA:
      value["customerSpecificPricingRequiresLOA"],
    customerSpecificPricingUsesRateSheet:
      value["customerSpecificPricingUsesRateSheet"],
    usesFCAFuelSurcharge: value["usesFCAFuelSurcharge"],
    documentFetchCutOffDays: value["documentFetchCutOffDays"],
  };
}
